import { useTranslation } from 'react-i18next';
import { EmptyState } from '@/components/empty/EmptyState';

interface TasksEmptyStateProps {
  onCreateTask: () => void;
}

/**
 * Empty state shown when no open tasks remain
 * Cheerful message with call-to-action
 */
export function TasksEmptyState({ onCreateTask }: TasksEmptyStateProps) {
  const { t } = useTranslation('notepad');

  return (
    <EmptyState
      type="all-done"
      title={t('empty.tasks', 'Geen open taken')}
      emoji="🎉"
      description={t('widget.allCaughtUp', 'Helemaal bij!')}
      action={{
        label: t('actions.addTask', 'Nieuwe taak'),
        onClick: onCreateTask,
      }}
    />
  );
}
